import React, { useEffect, useState } from "react";

const PrintHeader = ({ reportTitle }) => {
  const currentDate = new Date().toISOString().slice(0, 10);
  const [userInfo, setUserInfo] = useState(null);
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
    }
  }, []);

  return (
    <div className="d-none d-print-block mt-2">
      <div className="text-center">
        {userInfo && (
          <>
            <h4 className="m-0 p-0">{userInfo?.organizationInfo?.name}</h4>
            <p className="m-0 p-0">{userInfo?.organizationInfo?.address1},{" "}{userInfo?.user?.phoneNumber}</p>
          </>
        )}
        <h4>{reportTitle}</h4>
      </div>
      <div className="d-flex justify-content-end">
        <span className="text-sm">Print Date: {currentDate}</span>
      </div>
    </div>
  );
};

export default PrintHeader;
